var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#e6007e;}.b,.c{fill-rule:evenodd;}.c{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13,.628,3.166,8.1a.5.5,0,0,0,.3.9H4.976l.476,9.525a.5.5,0,0,0,.5.475h14.1a.5.5,0,0,0,.5-.475L21.024,9h1.507a.5.5,0,0,0,.3-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.5,3.5h5a.5.5,0,0,1,0,1h-5a.5.5,0,0,1,0-1Z",
    transform: "translate(9 17) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.487,11.329l2.526.842a.347.347,0,0,1,.237.329.18.18,0,0,1-.237.171l-2.526-.842A.347.347,0,0,1,9.25,11.5a.18.18,0,0,1,.237-.171Z",
    transform: "translate(-1.25 22.75) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.987,12.171l2.526-.842a.18.18,0,0,1,.237.171.347.347,0,0,1-.237.329l-2.526.842a.18.18,0,0,1-.237-.171A.347.347,0,0,1,13.987,12.171Z",
    transform: "translate(3.25 27.25) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.75,11.75h2.5a.25.25,0,0,1,0,.5h-2.5a.25.25,0,0,1,0-.5Z",
    transform: "translate(1 25) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.743,15.561l1.515.379a.32.32,0,0,1,.243.311.2.2,0,0,1-.243.189l-1.515-.379A.32.32,0,0,1,8.5,15.75a.2.2,0,0,1,.243-.189Z",
    transform: "translate(-6.5 25.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.743,15.939l1.515-.379a.2.2,0,0,1,.243.189.32.32,0,0,1-.243.311l-1.515.379a.2.2,0,0,1-.243-.189A.32.32,0,0,1,15.743,15.939Z",
    transform: "translate(0.5 32.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.25,15.75h1.5a.25.25,0,0,1,0,.5h-1.5a.25.25,0,0,1,0-.5Z",
    transform: "translate(-3 29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.289,8.514A2.551,2.551,0,0,0,16.5,7.5a3.279,3.279,0,0,0-3.5-3,3.279,3.279,0,0,0-3.5,3,2.614,2.614,0,0,0,.205,1.014V9.5h6.584Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.759569f0df8b827158363884b6a33de8.svg";
export { ForwardRef as ReactComponent };